import { useCallback, useMemo } from 'react';
import { OnboardingProTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import { useOnboardingShallowStore } from '@frontend/product-onboarding';
import { CALL_INTEL_PRO_ONBOARDING_HOTSPOT_KEYS } from '../constant';
import { useProOnboardingActionShallowStore } from './use-pro-onboarding-action-store';

type UseProOnboardingActiveOpportunitiesTooltipArgs = {
  enabled?: boolean;
};

export function useProOnboardingActiveOpportunitiesTooltip({
  enabled = true,
}: UseProOnboardingActiveOpportunitiesTooltipArgs = {}) {
  const { completeHotspot, completedHotspots } = useOnboardingShallowStore('completeHotspot', 'completedHotspots');

  const { pendingTask, clearPendingTask } = useProOnboardingActionShallowStore('pendingTask', 'clearPendingTask');

  const hotspotKey = CALL_INTEL_PRO_ONBOARDING_HOTSPOT_KEYS.OVERVIEW_ACTIVE_OPPORTUNITIES_INFO_ICON;

  const isReady = enabled && pendingTask === OnboardingProTask.PRO_TASK_OVERVIEW_INSIGHTS;

  const shouldAutoOpenTooltip = useMemo(() => {
    return isReady && !completedHotspots.has(hotspotKey);
  }, [isReady, completedHotspots, hotspotKey]);

  const completeActiveOpportunitiesTooltip = useCallback(() => {
    if (!isReady) return;
    clearPendingTask();
    if (!completedHotspots.has(hotspotKey)) {
      completeHotspot(hotspotKey);
    }
  }, [isReady, clearPendingTask, completedHotspots, hotspotKey, completeHotspot]);

  return {
    shouldAutoOpenTooltip,
    completeActiveOpportunitiesTooltip,
  };
}
